import script from "./Realtime.vue?vue&type=script&setup=true&lang=js"
export * from "./Realtime.vue?vue&type=script&setup=true&lang=js"

import "./Realtime.vue?vue&type=style&index=0&id=534f7bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534f7bf2"]])

export default __exports__